import type { AddToCartButtonProps } from '@maestro/commerce-blocks/components/add-to-cart-button/add-to-cart-button.types'

import { AddToCartButton } from '@maestro/commerce-blocks/components/add-to-cart-button'

export default function ProductCardAddToCartButtonWrapper(
  props: AddToCartButtonProps
) {
  const { product } = props
  const needsVariantSelection =
    product.variants.length > 1 &&
    !product.variants.some((variant) => variant.id === product.id)

  return (
    <AddToCartButton
      {...props}
      {...(needsVariantSelection ? { url: `/${product.urlPath}` } : {})}
    />
  )
}
